<template>
    <div style="display: flex;height: 100%;padding: 6px;gap: 12px;">
        <StationSide @node-click="nodeClick"/>
        <div style="height: 100%;flex: 1;display: flex;flex-direction: column;">
            <QueryForm ref="queryForm" :dataSource='queryFormData' @search="search" :showClear="false"/>
            <div class="ag-theme-material" style="flex: 1;">
            <ag-grid-vue
            style="width: 100%; height: 100%;"
            :suppressNoRowsOverlay="true"
            autoSizePadding="10"
            editType="fullRow"
            :rowHeight="40"
            :headerHeight="40"
            :gridReady="onGridReady"
            :columnDefs="columnDefs"
            :rowData="rowData"
            >
            </ag-grid-vue>
        </div>
        <div style="display: flex;justify-content: center;color:white;">
            <PageCustom
            :current='pageNum'
            :pageSize='pageSize'
            :total="total"
            :showElevator='true'
            :showSizer='true'
            :showTotal='true'
            :pageSizeChanged="pageSizeChanged"
            :pageChanged="pageChanged"
            ></PageCustom>
        </div>
    </div>
</div>
</template>

<script>
import AgGridVueCustomTsx, { ColDefCustom } from 'src/components/agGridCustom/agGridVueCustomTsx';
import CellRenderTsx from 'src/components/agGridComponent/cellRenderTsx';
import axios from 'axios';
import StationSide from '@/pages/systemMessage/components/stationSide.vue';
import { all_data, get_water_collection_info } from './api';
import QueryForm from 'src/components/queryForm/queryForm';
import DatePicker from 'src/types/iview/DatePicker';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
import PageCustom, { PageCustomProps } from 'src/components/pageCustom/pageCustom.tsx';
export default {
    components: {
        AgGridVueCustomTsx,
        CellRenderTsx,
        StationSide,
        QueryForm,
        PageCustom,
    },
    data() {
        return {
            host: '',
            queryFormData: [
                {
                    component: DatePicker,
                    label: '时间',
                    field: 'time',
                    width: 300,
                    realField: ['beginTime', 'endTime'],
                    props: { value: DateTimeUtil.getDayInterval(7), type: 'daterange', format: 'yyyy-MM-dd', placeholder: '请选择时间' },
                },
            ],
            pageNum: 1,
            pageSize: 20,
            total: 0,
            inline: false,
            form: {},
            formData: [],
            columnDefs: [],
            rowData: [],
            data: {},
        };
    },
    methods: {
        onGridReady(params) {
            params.api.sizeColumnsToFit();
        },
        pageSizeChanged(pageSize) {
            this.pageSize = pageSize;
            this.search()
        },
        pageChanged(pageNum) {
            this.pageNum = pageNum;
            this.search()
        },
        async search() {
            // this.pageNum = 1;
            // this.pageSize = 20;
            // this.total = 0;
            this.rowData = [];
            const {data} = await axios.post(`${this.host}/api/water/getSampleDeviceLog/byTime`, {
                ...this.$refs.queryForm.getQueryObj(),
                pageNum: this.pageNum,
                pageSize: this.pageSize,
            });
            console.log('获取到的数据:', data);
            if (data.code == "200") {
                this.total=+data.data.total
                this.rowData = data.data.list;
                this.columnDefs = [
                    {
                        headerName: '序号',
                        field: 'DateTime',
                        width: 50,
                        cellRendererFramework: CellRenderTsx,
                        cellRendererFrameworkOpt: {
                            cellRender:(h, params)=> {
                                return h('span',(this.pageNum-1)*this.pageSize+params.rowIndex+1);
                            },
                        },
                    },
                    {
                        headerName: '时间',
                        field: 'dataTime',
                        width: 600,
                    },
                    {
                        headerName: '日志内容',
                        field: 'logContent',
                        width: 900,
                    },
                ];
            }
        },
        nodeClick(item) {
            console.log('点击了节点:', item);
            this.host = item.api;
            this.search();
        },
    },
};
</script>

<style scoped lang="less">
</style>
